import {
    prop,
    pipe,
    find,
    propEq
} from 'core/utils';

export const mediateReportInfoDependent = (name) => pipe(
    prop('reports'),
    find(propEq('name', name))
);

export const mediateReportsInfoDependent = prop('reports');
